import type { TypeElements } from '../../types/element';

import prependChild from './prependChild';
import prependChildAtIndex from './prependChildAtIndex';
import prependChildren from './prependChildren';

// ----------------------------------------------------------------------------

declare global {
    interface Node {
        prependChild(element: Node): Node;
        prependChildAtIndex(element: Node, index: number): Node;
        prependChildren(elements: TypeElements): Node;
    }
}

// ----------------------------------------------------------------------------

Node.prototype.prependChild = function (element: Node): Node {
    prependChild(this, element);

    return this;
};

Node.prototype.prependChildAtIndex = function (element: Node, index: number): Node {
    prependChildAtIndex(this, element, index);

    return this;
};

Node.prototype.prependChildren = function (elements: TypeElements): Node {
    prependChildren(this, elements);

    return this;
};
